/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum LocatorBeneficiariosAliases {
  BUTTON_CONFIRMAR = 'button-confirmar',
  CONTEXTUAL_BAR_0 = 'contextual-bar-0',
  DATE_FIELD_0 = 'date-field-0',
  DECK_BENEFICIARIOS = 'deck-beneficiarios',
  FETCH_BENEFICIARIOS = 'fetch-beneficiarios',
  FIELD_2 = 'field-2',
  FIELD_BENEF = 'field-benef',
  FIELD_CPF = 'field-cpf',
  FIELD_DATA = 'field-data',
  FIELD_NOME_SOCIAL = 'field-nome-social',
  FIELD_TITULAR = 'field-titular',
  FILTER_BENEFICIARIOS = 'filter-beneficiarios',
  FILTERED_LIST_EXCLUSAO_BENEFICIARIOS = 'filtered-list-exclusao-beneficiarios',
  GLOBAL_ACTIONS_0 = 'global-actions-0',
  HPMS_CUSTOM_CARD_BENEFICIARIOS = 'hpms-custom-card-beneficiarios',
  INPUT_0 = 'input-0',
  INPUT_1 = 'input-1',
  INPUT_CPF = 'input-cpf',
  PANEL_LOCATOR_BENEFICIARIOS = 'panel-locator-beneficiarios',
  TEXT_1 = 'text-1',
  TEXT_2 = 'text-2',
}
export { LocatorBeneficiariosAliases };
